import { lazy } from "react";

const SalesReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.SalesReports }))
);
const PaymentReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.PaymentReports }))
);
const TaxReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.TaxReports }))
);
const UserReports = lazy(() =>
  import("../Report").then((m) => ({ default: m.UserReports }))
);
const RegClosuresReports = lazy(() =>
  import("../Report/RegisterClosures/RegClosuresReports")
);
const ViewRegister = lazy(() =>
  import("../Report/RegisterClosures/ViewRegister/ViewRegister")
);
const CreditCustomer = lazy(() =>
  import("../Report/CreditCustomer/CreditCustomer")
);
const ProductPerform = lazy(() =>
  import("../Report/ProductPerform/ProductPerform")
);
const RetailReport = lazy(() =>
  import("../Report/Retail/RetailReport")
);
const StockMovement = lazy(() =>
  import("../Inventory/Stock/StockMovement/StockMovement")
);
const ItemWiseSales = lazy(() =>
  import("../Report/ItemWiseSales/ItemWiseSales")
);
const CustomerWisePL = lazy(() =>
  import("../Report/CustomerWisePL/CustomerWisePL")
);
const ExpenseReport = lazy(() =>
  import("../Report/ExpenseReport/ExpenseReport")
);
const ProfitByInvoice = lazy(() =>
  import("../Report/ProfitByInvoice/ProfitByInvoice")
);
const SalesSummary = lazy(() =>
  import("../Report/SalesSummary/SalesSummary")
);
const BusinessActivity = lazy(() =>
  import("../Report/BusinessActivity/BusinessActivity")
);
const StockReport = lazy(() =>
  import("../Report/StockReport/StockReport")
);
const LogReport = lazy(() =>
  import("../Report/LogReport/LogReport")
);

export const reportRoutes = (access, settings) => {
  if (!settings?.fiscalYearId || !access.reportAccess) return [];

  return [
    { path: "/sales_reports", element: SalesReports, title: "salesReports" },
    { path: "/payment_reports", element: PaymentReports, title: "paymentReports" },
    { path: "/register_closures", element: RegClosuresReports, title: "registerClosures" },
    { path: "/view_register/:id", element: ViewRegister, title: "viewRegister" },
    { path: "/tax_reports", element: TaxReports, title: "taxReports" },
    { path: "/user_reports", element: UserReports, title: "userReports" },
    { path: "/credit_customer_report", element: CreditCustomer, title: "creditCustomerReport", enabled: access.report?.creditCustomer },
    { path: "/stock_movements_report", element: StockMovement, title: "stockMovements", enabled: access.report?.productMovement },
    { path: "/product_perform_report", element: ProductPerform, title: "productPerformance", enabled: access.report?.productMovement },
    { path: "/retail_dashboard", element: RetailReport, title: "retailDashboard" },
    { path: "/item_wise_sales", element: ItemWiseSales, title: "itemWiseSales", enabled: access.report?.itemWiseSales },
    { path: "/customer_wise_pl", element: CustomerWisePL, title: "customerWisePL", enabled: access.report?.customerWiseProfitLoss },
    { path: "/expense_report", element: ExpenseReport, title: "expenseReport", enabled: access.report?.expenseReport },
    { path: "/profit_by_invoice", element: ProfitByInvoice, title: "profitByInvoice", enabled: access.report?.profitByInvoice },
    { path: "/sales_summary", element: SalesSummary, title: "salesSummary" },
    { path: "/business_activity", element: BusinessActivity, title: "businessActivity", enabled: access.report?.businessActivity },
    { path: "/stock_report", element: StockReport, title: "stockReport", enabled: access.report?.stockReport },
    { path: "/log_report", element: LogReport, title: "logReport", enabled: access.report?.logReport },
  ];
};
